import React from 'react'

import { connect } from 'react-redux'
import { DropdownItem } from "semantic-ui-react";
import { DropdownMenu } from "semantic-ui-react";
import { Dropdown } from "semantic-ui-react";
import { Menu } from 'semantic-ui-react';
import { destroyEntity } from "../../../actions/entities";
import { updateEntity } from "../../../actions/entities";
import { upsertEntity } from "../../../actions/entities";
import DestroyModal from "../../generics/DestroyModal";
import { getPrintDropdownItem } from "../../printing/PrintableComponent";
import { getCurrentEmployment } from "../../../selectors/employments";

class ActionsMenu extends React.Component {

  render() {
    const {noteId, attachmentId, printRef} = this.props

    return (
      <Menu.Item>
        <Dropdown key={'dossier_actions_dropdown'} button floating direction="left" className="icon"
                  icon="ellipsis horizontal" active="">
          <DropdownMenu>
            {printRef && getPrintDropdownItem(printRef)}
            {attachmentId && this.renderAttachmentVisibilityToggle()}
            {noteId && this.renderDestroyButton('note', noteId)}
            {attachmentId && this.renderDestroyButton('attachment', attachmentId)}
          </DropdownMenu>
        </Dropdown>
      </Menu.Item>)
  }

  renderAttachmentVisibilityToggle() {
    const { attachmentType } = this.props
    if (attachmentType === 'pdf' || attachmentType === 'image') {
      const preferenceNameByType = {
        pdf: 'showInlinePdfs',
        image: 'showInlineImages',
      }
      const preferenceName = preferenceNameByType[attachmentType]

      const action = this.props[preferenceName] ?  'hide' : 'show'
      const icon = this.props[preferenceName] ? 'eye slash' : 'eye'
      const buttonText = I18n.t(`components.dossier_item.toggle_visibility.${attachmentType}.${action}`)
      return (
        <DropdownItem icon={icon} onClick={() => this.props.toggleVisibility(preferenceName)} text={buttonText}/>
      )
    }
    return null
  }

  renderDestroyButton(type, itemId){
    return(<DestroyModal easy handleDestroy={() => this.props.destroyDossierItem(itemId)} trigger={(props) => {
      return (<DropdownItem icon="trash alternate outline" className="destructive-dropdown-item" onClick={props.onClick}
                           text={I18n.t(`components.dossier_item.destroy.${type}`)}/>)
    }}
    />)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    destroyDossierItem: (id) => {
      dispatch(destroyEntity('dossierItem', id))
    },
    toggleVisibility: (preferenceName) => {
      dispatch((innerDispatch, getState) => {
        const currentEmployment = getCurrentEmployment(getState())
        if (!currentEmployment) return

        const currentValue = currentEmployment[preferenceName] !== false
        const nextValue = !currentValue
        innerDispatch(updateEntity('employment', { id: currentEmployment.id, [preferenceName]: nextValue }))
        innerDispatch(upsertEntity('employment', currentEmployment.id))
      })
    }
  }
}

const mapStateToProps = (state) => {
  const currentEmployment = getCurrentEmployment(state)

  return {
    showInlineImages: currentEmployment?.showInlineImages !== false,
    showInlinePdfs: currentEmployment?.showInlinePdfs !== false,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ActionsMenu)
